export class PrescriptionDrugMessages {
  constructor() {
    this.informationMessage = [];
    this.warningMessage = [];
    this.errorMessage = [];
  }

  public informationMessage: string[];
  public warningMessage: string[];
  public errorMessage: string[];
}
